<template>
  <a :href="lineSharedUrl" :target="lineSharedTarget" @click="onLineShare" class="ShareLineButton">
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
      <g id="Group_1032" data-name="Group 1032" transform="translate(-1119 -10)">
        <rect id="Rectangle_506" data-name="Rectangle 506" width="30" height="30" transform="translate(1119 10)" fill="none"/>
        <g id="FULL_COLOR_ICON" data-name="FULL COLOR ICON" transform="translate(1123 14)">
          <g id="TYPE_A" data-name="TYPE A" transform="translate(0 0)">
            <g id="Group_397" data-name="Group 397">
              <path id="Subtraction_4" data-name="Subtraction 4" d="M10.812,21.8a.38.38,0,0,1-.308-.119.838.838,0,0,1-.057-.636l0-.024c.029-.172.163-.979.163-.979a2.2,2.2,0,0,0-.037-1.035c-.126-.312-.618-.479-1.008-.564C4.024,17.714,0,13.861,0,9.285,0,4.165,5.133,0,11.442,0S22.884,4.165,22.884,9.285A8.3,8.3,0,0,1,20.431,15a36.545,36.545,0,0,1-8.989,6.643A1.733,1.733,0,0,1,10.812,21.8ZM15.867,6.811a.225.225,0,0,0-.155.063l-.006.006a.222.222,0,0,0-.062.153v4.985a.225.225,0,0,0,.063.155l.006.006a.218.218,0,0,0,.154.062h3.206a.224.224,0,0,0,.223-.223v-.8a.223.223,0,0,0-.223-.222h-2.18V10.15h2.18a.223.223,0,0,0,.223-.222v-.8a.224.224,0,0,0-.223-.223h-2.18V8.06h2.18a.223.223,0,0,0,.223-.222v-.8a.224.224,0,0,0-.223-.223Zm-4.5,2.247,0,0,2.285,3.086a.236.236,0,0,0,.057.056l.016.01.007,0,.011.005h.005l.006,0,.006,0,.011,0h.008a.2.2,0,0,0,.057.008h.8a.223.223,0,0,0,.222-.222V7.034a.223.223,0,0,0-.222-.222h-.8a.223.223,0,0,0-.222.222V10L11.331,6.91l-.01-.014-.007-.009-.009-.009L11.3,6.873l0,0,0,0-.008-.006-.005,0-.006,0-.006,0-.007,0a.044.044,0,0,0-.012-.007l-.006,0-.007,0-.007,0-.007,0h-.006l-.015,0-.009,0-.013,0H11.17l-.005,0h-.822a.223.223,0,0,0-.223.222V12.02a.223.223,0,0,0,.223.222h.8a.223.223,0,0,0,.223-.222V9.059ZM8.314,6.811a.223.223,0,0,0-.223.222V12.02a.223.223,0,0,0,.223.222h.8a.223.223,0,0,0,.222-.222V7.034a.223.223,0,0,0-.222-.222Zm-4.338,0a.223.223,0,0,0-.223.222v4.985a.227.227,0,0,0,.062.155l.006.006a.222.222,0,0,0,.154.062H7.182a.223.223,0,0,0,.223-.223v-.8a.223.223,0,0,0-.223-.222H5V7.034a.223.223,0,0,0-.223-.222Z" :fill="iconColor" stroke="rgba(0,0,0,0)" stroke-width="1"/>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </a>
</template>

<script>
import Utils from 'udn-newmedia-utils'

export default {
  name: 'ShareLineButton',
  data () {
    return {
      isMobile: false,
      isInApp: false
    }
  },
  mounted () {
    this.isMobile = Utils.detectMob()
    this.isInApp = Utils.isFacebookApp(148) || Utils.isLineApp()
  },
  props: {
    iconColor: {
      type: String,
      default: '#7b7a7a'
    },
    href: {
      type: String,
      default: window.location.href
    }
  },
  computed: {
    lineSharedUrl () {
      // let sharedUrl = this.sharedUrl
      let sharedText = document.querySelector('title').innerHTML
      let shareContent = document.querySelector('meta[property="og:description"]').content
      // desktop
      if (!this.isMobile) {
        return `https://social-plugins.line.me/lineit/share?text=${encodeURIComponent(sharedText)}%0D%0A%0D%0A${encodeURIComponent(shareContent)}&url=${encodeURIComponent(this.href)}`
      }
      // mobile
      if (!this.isInApp) {
        return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(sharedText)}%0D%0A%0D%0A${encodeURIComponent(shareContent)}%0D%0A%0D%0A${encodeURIComponent(this.href)}`
      }
      // mobile in-app webview
      return `https://line.naver.jp/R/msg/text/?${encodeURIComponent(sharedText)}%0D%0A%0D%0A${encodeURIComponent(shareContent)}%0D%0A%0D%0A${encodeURIComponent(this.href)}`
    },
    lineSharedTarget () {
      if (!this.isMobile) {
        return '_blank'
      }
      return '_self'
    }
  },
  methods: {
    onLineShare () {
      this.handleLineGA()
      // if (Utils.detectMob()) {
      //   // 手機
      //   window.open("//line.me/R/msg/text/?" + document.querySelector('title').innerHTML + "%0D%0A%0D%0A" + document.querySelector('meta[property="og:description"]').content + "%0D%0A%0D%0A" + this.href)
      // } else {
      //   window.open("https://social-plugins.line.me/lineit/share?url=" + this.href)
      // }
    },
    handleLineGA () {
      window.ga("send", {
        "hitType": "event",
        "eventCategory": "share",
        "eventAction": "click",
        "eventLabel": "[" + Utils.detectPlatform() + "] [" + document.querySelector('title').innerHTML + "] [ Click_Linetop_" + document.querySelector('title').innerHTML + "]"
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.ShareLineButton {
  cursor: pointer;
  &:hover #Subtraction_4 {
    fill: #57b09f !important;
    transition: all .5s;
  }
}
</style>
